import { ToggleType } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { currentTaskInfoAtom } from '../../../../../atoms/bi-atoms';
import { AnalysisState, usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useQueryRuleExecutionResultsQuery } from '../../../../../queries/use-query-rule-execution-results-query';
import { useBasePageGroup } from '../use-base-page-group';
import { useStaticPageRuleResults } from './use-static-page-rule-results';
export const useStaticPageGroup = pageId => {
  const {
    refetch: refetchRuleExecutionResults
  } = useQueryRuleExecutionResultsQuery(pageId, () => {});
  const {
    getGroupData
  } = usePanelStateAtom();
  const setCurrentTaskInfo = useSetAtom(currentTaskInfoAtom);
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const ruleResults = useStaticPageRuleResults(pageId);
  const groupData = getGroupData(pageId);
  if (!groupData) {
    throw new Error(`Group data not found for pageId: ${pageId}.`);
  }
  const {
    itemType,
    analysisState
  } = groupData;
  const onGroupToggle = useCallback((toggleType, groupIndex) => {
    if (toggleType === ToggleType.Expand) {
      setIsGroupOpen(true);
    } else if (toggleType === ToggleType.Collapse) {
      setIsGroupOpen(false);
    }
    setCurrentTaskInfo(taskInfo => ({
      ...taskInfo,
      page_id: pageId,
      page_index: groupIndex,
      page_type: itemType
    }));
  }, [pageId, itemType, setCurrentTaskInfo]);

  // Auto-fetch when group is open and results become pending
  useEffect(() => {
    if (isGroupOpen && analysisState === AnalysisState.AnalyzeDonePendingResults) {
      refetchRuleExecutionResults();
    }
  }, [analysisState, isGroupOpen, refetchRuleExecutionResults]);
  const {
    ruleGroupProps
  } = useBasePageGroup({
    onGroupToggleCallback: onGroupToggle,
    pageId,
    ruleResults
  });
  return {
    staticPageRuleGroupProps: ruleGroupProps
  };
};
//# sourceMappingURL=use-static-page-group.js.map